import { useEffect } from "react";
import { X } from "lucide-react";
import { buildSignedUrl } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

export function Lightbox({ item, onClose }) {
    useEffect(() => {
        function onKey(e) { if (e.key === "Escape") onClose && onClose(); }
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);
    if (!item) return null;
    const url = buildSignedUrl(item.signed_url);
    const isVideo = (item.category || "").startsWith("video");
    const isPdf = item.mime_type === "application/pdf";
    return (
        <div
            className="fixed inset-0 z-50 grid place-items-center bg-black/85 p-4 backdrop-blur-sm"
            onClick={onClose}
            data-testid="lightbox"
        >
            <button
                onClick={onClose}
                aria-label="Close"
                className="absolute right-4 top-4 rounded-full bg-white/15 p-2 text-white hover:bg-white/30"
                data-testid="lightbox-close"
            >
                <X className="h-5 w-5" />
            </button>
            <div className="flex max-h-[90vh] max-w-[90vw] flex-col gap-3" onClick={(e) => e.stopPropagation()}>
                {isVideo ? (
                    <video src={url} controls autoPlay className="max-h-[78vh] rounded-md bg-black" />
                ) : isPdf ? (
                    <iframe title={item.original_filename} src={url} className="h-[80vh] w-[80vw] rounded-md bg-white" />
                ) : (
                    <img src={url} alt={item.caption || item.original_filename} className="max-h-[78vh] rounded-md object-contain" />
                )}
                <div className="text-xs text-zinc-300">
                    <div className="font-medium text-white">{item.caption || item.original_filename}</div>
                    <div className="font-mono opacity-80">
                        {item.kind} · {item.mime_type} · {(item.size_bytes / 1024).toFixed(0)} KB
                        {item.taken_at ? ` · ${formatDateTime(item.taken_at)}` : ""}
                    </div>
                </div>
            </div>
        </div>
    );
}
